// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_fdB","cls2":"SimplePaperPodcast-cls2_x7n SimplePaperPodcast-cls1_fdB"};